export default "/assets/images/technology-hero.80c91ebde4824c30.jpg";